import { render, staticRenderFns } from "./FacebookFeed.vue?vue&type=template&id=2403d9ec&"
import script from "./FacebookFeed.vue?vue&type=script&lang=js&"
export * from "./FacebookFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports